export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9701.2b3ad57e.jpg";